import React from "react";
import dayjs from "dayjs";
import { Modal, ModalBody } from "../../ui";
import "./WelcomeModal.scss";

const getProductName = (productId) => {
  if (productId === 3) return "Monthly";
  if (productId === 4) return "Quarterly";
  if (productId === 5) return "Lifetime";
  return "Annual";
};

const WelcomeModal = ({
  isOpen,
  onClose,
  userDetails,
  renewal,
  onTermsClick,
}) => {
  const isNftLifetime =
    userDetails?.productId === 5 && userDetails?.paymentMethodId === 5;
  const productName = getProductName(userDetails?.productId);
  const displayName = userDetails?.name || "member";

  return (
    <Modal
      centered
      size="lg"
      isOpen={isOpen}
      toggle={onClose}
      className="welcome-modal"
    >
      <ModalBody className="welcome-modal__body">
        <button
          type="button"
          className="welcome-modal__close"
          onClick={onClose}
          aria-label="Close welcome message"
        >
          <span className="material-icons" aria-hidden="true">
            close
          </span>
        </button>

        <div className="welcome-modal__hero">
          <div className="welcome-modal__icon" aria-hidden="true">
            <span className="material-icons">check</span>
          </div>
          <h2 className="welcome-modal__title">Welcome, {displayName}!</h2>
          <p className="welcome-modal__subtitle">
            Your membership is active. You&apos;re ready to explore Bitcoin Live.
          </p>
        </div>

        <div className="welcome-modal__cards">
          <div className="welcome-modal__card">
            <p className="welcome-modal__card-label">Your Plan</p>
            <p className="welcome-modal__card-value">{productName}</p>
            {isNftLifetime ? (
              <p className="welcome-modal__card-note">
                Full access continues while you hold the NFT in your registered
                wallet. If it moves, re-confirm access from your Profile page.
              </p>
            ) : (
              <p className="welcome-modal__card-note">
                Auto-renews on{" "}
                <strong>
                  {renewal
                    ? dayjs(renewal).format("MMMM D, YYYY")
                    : "your billing date"}
                </strong>
                .
              </p>
            )}
          </div>

          <div className="welcome-modal__card">
            <p className="welcome-modal__card-label">Sign In With</p>
            <p className="welcome-modal__card-value welcome-modal__card-value--email">
              {userDetails?.email}
            </p>
            <p className="welcome-modal__card-note">
              Use the password you created at registration.
            </p>
          </div>
        </div>

        <div className="welcome-modal__tips">
          <ul>
            <li>
              <span className="welcome-modal__tip-label">Profile</span>
              <span>
                (top right) — notifications, password, display name, and
                billing.
              </span>
            </li>
            <li>
              <span className="welcome-modal__tip-label">Support</span>
              <span>(bottom right) — reach our team anytime.</span>
            </li>
            <li>
              <button
                type="button"
                className="welcome-modal__link"
                onClick={onTermsClick}
              >
                Terms of service
              </button>
              <span>— membership terms and policies.</span>
            </li>
          </ul>
        </div>

        <button
          type="button"
          className="welcome-modal__cta"
          onClick={onClose}
        >
          Start exploring
        </button>
      </ModalBody>
    </Modal>
  );
};

export default WelcomeModal;
